const InviteEventWebPageEmailTypeEnum = {
  Invitation: 'Invitation',
  InvitationReminder: 'Reminder',
  Custom: 'Custom',
};

export default Object.freeze(InviteEventWebPageEmailTypeEnum);
